<template lang="pug">
 .horse-card
    md-table
      md-table-row
      md-table-row
        md-table-cell {{$t('label.paard')}}
        md-table-cell
        md-table-cell(md-numeric) {{horse.name}}
      md-table-row
        md-table-cell {{$t('label.ras')}}
        md-table-cell
        md-table-cell(md-numeric) {{breed.name}}
      md-table-row
        md-table-cell {{$t('label.gewicht')}}
        md-table-cell
        md-table-cell(md-numeric) {{horse.weight}} kg
      md-table-row
        md-table-cell {{$t('label.phase')}}
        md-table-cell(md-numeric) {{ phaseType.name }}
        md-table-cell(md-numeric) {{ phase.name }}
      md-table-row
        md-table-cell {{$t('label.activity')}}
        md-table-cell(md-numeric) {{ activityType.name }}
        md-table-cell(md-numeric) {{ activity.name }}
</template>
<script>
import { mapGetters, mapState } from 'vuex'
export default {
  computed: {
    ...mapState([
      'language',
      'horse',
      'user',
      'breedTypeIdx',
      'breedIdx',
      'breeds',
      'activityTypeIdx',
      'activityIdx',
      'activities',
      'phaseTypeIdx',
      'phaseIdx',
      'phases',
      'weights',
      'info'
    ]),
    ...mapState({
      weightID: 'weight'
    }),
    ...mapGetters([
      'ration',
      'breedType',
      'breed',
      'weight',
      'phaseType',
      'phase',
      'activityType',
      'activity',
      'materials',
      'krachtvoer',
      'ruwvoer',
      'supplement'
    ])
  },
  methods: {
    dataInfoTable () {
      var rows = [
        [{ text: 'Horse Data', alignment: 'left', colSpan: 3, fontSize: 12 }, {}, {}],
        [this.$t('label.naam'), { text: this.horse.name, colSpan: 2, alignment: 'right' }, {}],
        [this.$t('label.ras'), { text: this.breed.name, colSpan: 2, alignment: 'right' }, {}],
        [this.$t('label.gewicht'), { text: this.horse.weight + ' kg', colSpan: 2, alignment: 'right' }],
        [this.$t('label.phase'), { text: this.phaseType.name, alignment: 'center' }, { text: this.phase.name, alignment: 'right' }],
        [this.$t('label.activity'), { text: this.activityType.name, alignment: 'center' }, { text: this.activity.name, alignment: 'right' }]
      ]
      let table = {
        table: {
          headerRows: 1,
          widths: ['auto', '*', '*'],
          body: rows
        },
        layout: 'headerLineOnly',
        margin: [0, 0, 0, 10]
      }
      return table
    }
  }
}
</script>
<style scoped>
.md-table {
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/HorseCard.vue